import {
  SHL,
  NHS,
  SHUK,
  UKCA,
  CWFT,
  TestMe,
  Preventx,
  Graphite,
  TestForMe,
  FreeTestMe,
  PreventxUKAS,
  SoapoliOnline,
  HeartOfTheCity,
  CyberEssentials,
  CyberEssentialsPlus,
  CareQualityCommission,
  LloydsPharmacyOnlineDoctor,
} from '@preventx/oxygen';
import { AllBrands } from '@preventx/prismic-services';

type BrandLogoProps = {
  logo: AllBrands;
  addServiceLogoClass?: boolean;
};

export const BrandLogo = ({
  logo,
  addServiceLogoClass = true,
}: BrandLogoProps) => (
  <>
    {logo === 'SHL' && <SHL addServiceLogoClass={addServiceLogoClass} />}
    {logo === 'NHS' && <NHS addServiceLogoClass={addServiceLogoClass} />}
    {logo === 'CWFT' && <CWFT addServiceLogoClass={addServiceLogoClass} />}
    {logo === 'UKCA' && <UKCA addServiceLogoClass={addServiceLogoClass} />}
    {logo === 'SH.UK' && <SHUK addServiceLogoClass={addServiceLogoClass} />}

    {logo === 'UKAS Medical - Preventx' && (
      <PreventxUKAS addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Heart of the City' && (
      <HeartOfTheCity addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Preventx' && (
      <Preventx addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Preventx - Graphite' && (
      <Graphite addServiceLogoClass={addServiceLogoClass} />
    )}

    {(logo === 'Test.me' || logo === 'Test.me - New') && (
      <TestMe addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'FreeTest.me' && (
      <FreeTestMe addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Cyber Essentials' && (
      <CyberEssentials addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Cyber Essentials Plus' && (
      <CyberEssentialsPlus addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Test For Me' && (
      <TestForMe addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Soapoli Online' && (
      <SoapoliOnline addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Care Quality Commission' && (
      <CareQualityCommission addServiceLogoClass={addServiceLogoClass} />
    )}

    {logo === 'Lloyds Pharmacy Online Doctor' && (
      <LloydsPharmacyOnlineDoctor addServiceLogoClass={addServiceLogoClass} />
    )}
  </>
);
